// src/UI/Upload/InputFileUpload.jsx

import React, { useRef, useState } from "react";

import { Button, MetreaTooltip } from "@metrea-ui/v2";

import { getShortDateTimeString } from "src/utils/formatUtils";
import { useUpdateEffect } from "react-use";

export const InputFileUpload = (props) => {
	const renderCount = useRef(0);
	renderCount.current++;

	const ref = useRef();

	const [theFile, setTheFile] = useState(null);

	const changeHandler = async (event) => {
		const thisFile = event.target.files[0];
		if (!thisFile) return;

		const isJson = /\.(json)$/i.test(thisFile.name);
		const isPdf = /\.(pdf)$/i.test(thisFile.name);
		const maxJsonFileSizeBytes = Number.isFinite(props.maxJsonFileSizeBytes)
			? props.maxJsonFileSizeBytes
			: null;
		const maxPdfFileSizeBytes = Number.isFinite(props.maxPdfFileSizeBytes)
			? props.maxPdfFileSizeBytes
			: null;

		if (isJson) {
			if (maxJsonFileSizeBytes != null && thisFile.size > maxJsonFileSizeBytes) {
				setTheFile({
					filename: thisFile.name,
					fileType: "json",
					fileSizeBytes: thisFile.size,
					sizeLimitExceeded: true,
					importDt: getShortDateTimeString(new Date(), false),
				});
				event.target.value = null;
				return;
			}

			const fileReader = new FileReader();
			fileReader.readAsText(thisFile, "UTF-8");
			fileReader.onload = (event) => {
				try {
					const data = JSON.parse(event.target.result);
					setTheFile({
						...data,
						filename: thisFile.name,
						fileType: "json",
						fileSizeBytes: thisFile.size,
						importDt: getShortDateTimeString(new Date(), false),
					});
				} catch (_error) {
					setTheFile({
						filename: thisFile.name,
						fileType: "json",
						fileSizeBytes: thisFile.size,
						parseError: true,
						importDt: getShortDateTimeString(new Date(), false),
					});
				}
			};

			// debugLog(10, "[InputFileUpload] - changeHandler", {
			// 	"event.target": event.target,
			// 	thisFile: thisFile,
			// 	"event.target.files[0]": event.target.files[0],
			// });

			// reset ReactJS file input
			event.target.value = null;
		} else if (isPdf) {
			if (maxPdfFileSizeBytes != null && thisFile.size > maxPdfFileSizeBytes) {
				setTheFile({
					filename: thisFile.name,
					fileType: "pdf",
					file: thisFile,
					fileSizeBytes: thisFile.size,
					sizeLimitExceeded: true,
					importDt: getShortDateTimeString(new Date(), false),
				});
				event.target.value = null;
				return;
			}

			setTheFile({
				filename: thisFile.name,
				fileType: "pdf",
				file: thisFile,
				fileSizeBytes: thisFile.size,
				importDt: getShortDateTimeString(new Date(), false),
			});
			event.target.value = null;
		} else {
			setTheFile({
				filename: thisFile.name,
				fileSizeBytes: thisFile.size,
				invalidType: true,
				importDt: getShortDateTimeString(new Date(), false),
			});
			event.target.value = null;
		}
	};

	const clickHandler = () => {
		// Simulate a click on the hidden file input
		ref.current.click();
	};

	useUpdateEffect(() => {
		props.onLoad(theFile);
	}, [theFile]);

	// debugLog(10, "[InputFileUpload] - changeHandler", {
	// 	renderCount: renderCount.current,
	// 	theFile: theFile
	// });

	const uploadButton = (
		<Button
			tabIndex={-1}
			size={props.size || "sm"}
			variant={props.variant || "solid"}
			className={props.buttonClassName}
			style={props.buttonStyle}
			onClick={clickHandler}
		>
			{props.label || "Upload"}
		</Button>
	);

	return (
		<>
			{/* Hidden file input */}
			<input
				style={{ display: "none" }}
				ref={ref}
				type="file"
				accept={props.accept || ".json"}
				onChange={changeHandler}
			/>

			{props.toolTip ? (
				<MetreaTooltip content={props.toolTip}>
					{uploadButton}
				</MetreaTooltip>
			) : (
				uploadButton
			)}
		</>
	);
};
